// extracted by mini-css-extract-plugin
module.exports = {"level-2-bg":"ArticleCategory_level-2-bg__H9Idr","content":"ArticleCategory_content__OpxHR","pagination":"ArticleCategory_pagination__4_rN9"};